import { DefaultUrlEnum } from '../enums/DefaultUrl.enum';
import { QueryParams } from '../enums/QueryParams.enum';

export class DefaultUrlBuilder {
  private readonly url: DefaultUrlEnum;

  constructor(baseUrl: string) {
    this.url = { baseResourceUrl: baseUrl };
  }

  queryString(qs: string): DefaultUrlBuilder {
    this.url.queryString = qs;
    return this;
  }

  sortBy(sb: string): DefaultUrlBuilder {
    this.url.sortBy = sb;
    return this;
  }

  orderBy(ob: string): DefaultUrlBuilder {
    this.url.orderBy = ob;
    return this;
  }

  offset(of: number): DefaultUrlBuilder {
    this.url.offset = of;
    return this;
  }

  limit(lt: number): DefaultUrlBuilder {
    this.url.limit = lt;
    return this;
  }

  filterBy(fb: string): DefaultUrlBuilder {
    this.url.filterBy = fb;
    return this;
  }

  build(): string {
    let urlToString: string = `${this.url.baseResourceUrl}?`;

    if (this.url.queryString !== undefined) {
      return `${urlToString}${this.url.queryString}`;
    }

    if (this.url.sortBy !== undefined) {
      urlToString += `${QueryParams.SORT_BY}=${this.url.sortBy}`;
    }

    if (this.url.orderBy !== undefined) {
      urlToString += `${QueryParams.ORDER_BY}=${this.url.orderBy}`;
    }

    if (this.url.filterBy !== undefined) {
      urlToString += `${QueryParams.FILTER_BY}=${this.url.filterBy}`;
    }

    if (this.url.offset !== undefined) {
      urlToString += `${QueryParams.OFFSET}=${this.url.offset}`;
    }

    if (this.url.limit !== undefined) {
      urlToString += `${QueryParams.LIMIT}=${this.url.limit}`;
    }

    return urlToString;
  }
}
